module.exports = __webpack_public_path__ + "static/CSF1-8b0d3f49ae109094b5c9010d3f42570f.png";